import { Grid, FormControlLabel } from "@material-ui/core";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import { CheckboxSmall, FieldSetStyles } from "../../styles";

type SourceContentExtractionConfProps = {
  ignoreDiffbotContent: boolean;
  onIgnoreDiffbotContentChange: () => void;
  ignoreStaticMetaImages: boolean;
  onIgnoreStaticMetaImagesChange: () => void;
  ignoreDiffbotImages: boolean;
  onIgnoreDiffbotImagesChange: () => void;
  ignoreDynamicAnalyzeImages: boolean;
  onIgnoreDynamicAnalyzeImages: () => void;
  diffbotPaginate: boolean;
  onDiffbotPaginateChange: () => void;
  ignoreShivaDocumentProbability: boolean;
  onignoreShivaDocumentProbabilityChange: () => void;
  diffbotForceArticleApi: boolean;
  onDiffbotForceArticleApiChange: () => void;
  ignoreDiffbotResolvedUrl: boolean;
  onIgnoreDiffbotResolvedUrlChange: () => void;
  useYoutubeDl: boolean;
  onUseYoutubeDlChange: () => void;
  useMetaTitle: boolean;
  onUseMetaTitleChange: () => void;
  ignoreDuplicateByTextCheck: boolean;
  onignoreDuplicateByTextCheckChange: () => void;
  useMetaDescription: boolean;
  onUseMetaDescriptionChange: () => void;
  useMetaImage: boolean;
  onUseMetaImageChange: () => void;
  disabled?: boolean;
};

export const SourceContentExtractionConf = ({
  ignoreDiffbotContent,
  onIgnoreDiffbotContentChange,
  ignoreStaticMetaImages,
  onIgnoreStaticMetaImagesChange,
  ignoreDiffbotImages,
  onIgnoreDiffbotImagesChange,
  ignoreDynamicAnalyzeImages,
  onIgnoreDynamicAnalyzeImages,
  diffbotPaginate,
  onDiffbotPaginateChange,
  ignoreShivaDocumentProbability,
  onignoreShivaDocumentProbabilityChange,
  diffbotForceArticleApi,
  onDiffbotForceArticleApiChange,
  ignoreDiffbotResolvedUrl,
  onIgnoreDiffbotResolvedUrlChange,
  useYoutubeDl,
  onUseYoutubeDlChange,
  useMetaTitle,
  onUseMetaTitleChange,
  useMetaDescription,
  onUseMetaDescriptionChange,
  useMetaImage,
  onUseMetaImageChange,
  ignoreDuplicateByTextCheck,
  onignoreDuplicateByTextCheckChange,
  disabled,
}: SourceContentExtractionConfProps) => {
  const fieldSetStyles = FieldSetStyles();

  return (
    <fieldset className={fieldSetStyles.container}>
      <legend>Content extraction settings:</legend>
      <Grid container>
        <Grid item xs={6}>
          <FormControlLabel
            control={
              <CheckboxSmall
                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                checkedIcon={<CheckBoxIcon fontSize="small" />}
                name="ignoreDiffbotContent"
                checked={ignoreDiffbotContent}
                onChange={onIgnoreDiffbotContentChange}
                disabled={disabled}
              />
            }
            label="Ignore Diffbot Content"
          />
        </Grid>
        <Grid item xs={6}>
          <FormControlLabel
            control={
              <CheckboxSmall
                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                checkedIcon={<CheckBoxIcon fontSize="small" />}
                name="ignoreStaticMetaImages"
                checked={ignoreStaticMetaImages}
                onChange={onIgnoreStaticMetaImagesChange}
                disabled={disabled}
              />
            }
            label="Ignore Meta Images (Static)"
          />
        </Grid>
        <Grid item xs={6}>
          <FormControlLabel
            control={
              <CheckboxSmall
                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                checkedIcon={<CheckBoxIcon fontSize="small" />}
                name="ignoreDiffbotImages"
                checked={ignoreDiffbotImages}
                onChange={onIgnoreDiffbotImagesChange}
                disabled={disabled}
              />
            }
            label="Ignore Diffbot Images"
          />
        </Grid>
        <Grid item xs={6}>
          <FormControlLabel
            control={
              <CheckboxSmall
                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                checkedIcon={<CheckBoxIcon fontSize="small" />}
                name="ignoreDynamicAnalyzeImages"
                checked={ignoreDynamicAnalyzeImages}
                onChange={onIgnoreDynamicAnalyzeImages}
                disabled={disabled}
              />
            }
            label="Ignore Meta Images (Rendered)"
          />
        </Grid>
        <Grid item xs={6}>
          <FormControlLabel
            control={
              <CheckboxSmall
                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                checkedIcon={<CheckBoxIcon fontSize="small" />}
                name="ignoreShivaDocumentProbability"
                checked={ignoreShivaDocumentProbability}
                onChange={onignoreShivaDocumentProbabilityChange}
                disabled={disabled}
              />
            }
            label="Treat all as Article (Custom Extraction)"
          />
        </Grid>
        <Grid item xs={6}>
          <FormControlLabel
            control={
              <CheckboxSmall
                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                checkedIcon={<CheckBoxIcon fontSize="small" />}
                name="diffbotForceArticleApi"
                checked={diffbotForceArticleApi}
                onChange={onDiffbotForceArticleApiChange}
                disabled={disabled}
              />
            }
            label="Treat all as Article (Diffbot)"
          />
        </Grid>
        <Grid item xs={6}>
          <FormControlLabel
            control={
              <CheckboxSmall
                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                checkedIcon={<CheckBoxIcon fontSize="small" />}
                name="diffbotPaginate"
                checked={diffbotPaginate}
                onChange={onDiffbotPaginateChange}
                disabled={disabled}
              />
            }
            label="Diffbot paginate"
          />
        </Grid>
        <Grid item xs={6}>
          <FormControlLabel
            control={
              <CheckboxSmall
                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                checkedIcon={<CheckBoxIcon fontSize="small" />}
                name="ignoreDiffbotResolvedUrl"
                checked={ignoreDiffbotResolvedUrl}
                onChange={onIgnoreDiffbotResolvedUrlChange}
                disabled={disabled}
              />
            }
            label="Ignore Diffbot Resolved URL"
          />
        </Grid>
        <Grid item xs={6}>
          <FormControlLabel
            control={
              <CheckboxSmall
                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                checkedIcon={<CheckBoxIcon fontSize="small" />}
                name="useYoutubeDl"
                checked={useYoutubeDl}
                onChange={onUseYoutubeDlChange}
                disabled={disabled}
              />
            }
            label="Use Youtube DL"
          />
        </Grid>
        <Grid item xs={6}>
          <FormControlLabel
            control={
              <CheckboxSmall
                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                checkedIcon={<CheckBoxIcon fontSize="small" />}
                name="useMetaTitle"
                checked={useMetaTitle}
                onChange={onUseMetaTitleChange}
                disabled={disabled}
              />
            }
            label="Use meta title"
          />
        </Grid>
        <Grid item xs={6}>
          <FormControlLabel
            control={
              <CheckboxSmall
                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                checkedIcon={<CheckBoxIcon fontSize="small" />}
                name="useMetaDescription"
                checked={useMetaDescription}
                onChange={onUseMetaDescriptionChange}
                disabled={disabled}
              />
            }
            label="Use meta description"
          />
        </Grid>
        <Grid item xs={6}>
          <FormControlLabel
            control={
              <CheckboxSmall
                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                checkedIcon={<CheckBoxIcon fontSize="small" />}
                name="useMetaImage"
                checked={useMetaImage}
                onChange={onUseMetaImageChange}
                disabled={disabled}
              />
            }
            label="Use meta image"
          />
        </Grid>
        <Grid item xs={6}>
          <FormControlLabel
            control={
              <CheckboxSmall
                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                checkedIcon={<CheckBoxIcon fontSize="small" />}
                name="ignoreDuplicateByTextCheck"
                checked={ignoreDuplicateByTextCheck}
                onChange={onignoreDuplicateByTextCheckChange}
                disabled={disabled}
              />
            }
            label="Ignore duplicate by text check"
          />
        </Grid>
      </Grid>
    </fieldset>
  );
};
